import { render } from "./onboarding-cost.vue?vue&type=template&id=21607d07"
import script from "./onboarding-cost.vue?vue&type=script&lang=js"
export * from "./onboarding-cost.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__